/**
 * Map of images extensions to MIME types
 */
export const imageExtMimeTypeMap = {
  jpeg: 'image/jpeg',
  png: 'image/png',
  ico: 'image/x-icon',
  svg: 'image/svg+xml',
} as const
